import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import AsyncSelect from "react-select/lib/Async";
import { NotificationManager } from "react-notifications";
import { NumberField, TextField } from "../../../../../../Utils/renderField/fieldsHookForms";
import { RenderKilogramo } from "../../../../../../Utils/renderField/renderReadField";
import { useDebouncedAsyncSelect } from "../../../../../../Utils/Hooks/useDebounce";
import { TIPOS_DESTINO_BODEGA_PT } from "../../../../../../../../utility/constants";
import { CreacionSalidaApi } from "../api/CreacionSalidaApi";
import { formatDisplayNumber } from "../../../../../../../../utility/utils";
import { formatSobranteLabel } from "../helpers/formatLabel";
import { tipoExistenciaSegunDestino } from "../helpers/filtroExistencias";
import Badge from "../../../../../../Utils/Badge/Badge";
import NullableValue from "../../../../../../Utils/renderField/nullableValue";
const eliminarIcon = require("assets/img/icons/borrar.png");

export const DetallesSalidaSobranteList = (props) => {
    const {
        almacenesReprocesoDisponibles,
        detallesSobrante = [],
        setDetallesSobrante,
        tipoDestinoSeleccionado,
    } = props;

    const esReclasificacion =
        tipoDestinoSeleccionado === TIPOS_DESTINO_BODEGA_PT.RECLASIFICACION;

    const esReproceso =
        tipoDestinoSeleccionado === TIPOS_DESTINO_BODEGA_PT.REPROCESO;

    const { getExistenciasSobranteBodega, getAlmacenesReproceso } =
        CreacionSalidaApi();

    const EliminarDetalleSobrante = async (index) => {
        setDetallesSobrante((prev) => prev.filter((_, i) => i !== index));
    };

    const {
        control: formControl,
        setValue: formSetValue,
        getValues: formGetValues,
        trigger: validateForm,
        watch: watchForm,
        formState: { errors },
    } = useForm({
        mode: "onChange",
    });

    const loadExistenciasSobrante = useDebouncedAsyncSelect(function (search) {
        if (!tipoDestinoSeleccionado) return Promise.resolve([]);

        return getExistenciasSobranteBodega({
            search: search,
            tipo: tipoExistenciaSegunDestino(tipoDestinoSeleccionado),
        });
    });

    const loadAlmacenesReproceso = useDebouncedAsyncSelect(function (search) {
        return getAlmacenesReproceso({ search: search });
    });

    const AgregarDetalleSobrante = async () => {
        const isValid = await validateForm();
        if (!isValid) return;

        const { existencia, kg_consumo, tarjeta_salida, bodega_destino } =
            formGetValues();

        const kgSecos = Number(kg_consumo);

        // no permitir despachar más kg de los disponibles en el saldo
        const existenciaKgNumber = Number(existencia.kg_secos);
        if (kgSecos > existenciaKgNumber) {
            NotificationManager.warning(
                `Solo hay ${formatDisplayNumber(existenciaKgNumber, 2)} Kg disponibles de ${existencia.producto}`,
                "Advertencia",
                3000,
            );
            return;
        }

        // evitar agregar dos veces el mismo saldo (producto + conforme)
        const yaAgregado = detallesSobrante.some(
            (detalle) => detalle.existencia_id === existencia.id,
        );

        if (yaAgregado) {
            NotificationManager.warning(
                `El sobrante de ${existencia.producto} ya fue agregado`,
                "Advertencia",
                3000,
            );
            return;
        }

        if (esReclasificacion && !tarjeta_salida) {
            NotificationManager.warning(
                "Debe indicar el número de tarjeta amarilla",
                "Advertencia",
                3000,
            );
            return;
        }

        if (esReproceso && !bodega_destino) {
            NotificationManager.warning(
                "Debe seleccionar el almacén de reproceso destino",
                "Advertencia",
                3000,
            );
            return;
        }

        const nuevoDetalle = {
            existencia_id: existencia.id,
            producto: existencia.producto,
            es_conforme_bodega: existencia.es_conforme_bodega,
            kg_disponibles: existencia.kg_secos,
            kg_secos: kgSecos,
            tarjeta_salida: esReclasificacion ? tarjeta_salida.trim() : null,
            bodega_destino_id: esReproceso ? bodega_destino.id : null,
            bodega_destino_nombre: esReproceso ? bodega_destino.nombre : null,
        };

        setDetallesSobrante((prev) => [...prev, nuevoDetalle]);

        formSetValue("existencia", null);
        formSetValue("kg_consumo", null);
        formSetValue("tarjeta_salida", null);
        formSetValue("bodega_destino", null);
    };

    const formValues = watchForm();

    useEffect(() => {
        formSetValue("existencia", null);
        formSetValue("kg_consumo", null);
        formSetValue("tarjeta_salida", null);
        formSetValue("bodega_destino", null);
    }, [tipoDestinoSeleccionado]);

    const existenciaSeleccionada = formValues.existencia;
    const limiteKg = existenciaSeleccionada
        ? existenciaSeleccionada.kg_secos
        : 0;

    return (
        <div className="mt-4 pt-4 border-top">
            <div className="d-flex justify-content-between flex-wrap align-items-end mb-3">
                <h4 className="mb-0">Kg secos sobrantes a despachar</h4>
                <div className="formulario-fields-row w-100 gap-1rem flex-wrap">
                    <div
                        className="formulario-field"
                        style={{ minWidth: "180px" }}
                    >
                        <label className="text-nowrap">Sobrante</label>
                        <Controller
                            name="existencia"
                            control={formControl}
                            rules={{
                                required: "Debe seleccionar un sobrante",
                            }}
                            render={({ field }) => (
                                <AsyncSelect
                                    {...field}
                                    key={tipoDestinoSeleccionado || "none"}
                                    className="react-select-container"
                                    isSearchable
                                    isClearable
                                    defaultOptions
                                    loadOptions={loadExistenciasSobrante}
                                    getOptionValue={(option) => option.id}
                                    getOptionLabel={(option) =>
                                        formatSobranteLabel(option)
                                    }
                                    onChange={(selected) => {
                                        field.onChange(selected);

                                        if (esReproceso) {
                                            const almacenSugerido = selected
                                                ? (
                                                      almacenesReprocesoDisponibles ||
                                                      []
                                                  ).find(
                                                      (almacen) =>
                                                          almacen.padre_producto_terminado_id ===
                                                          selected.padre_producto_terminado_id,
                                                  )
                                                : null;

                                            formSetValue(
                                                "bodega_destino",
                                                almacenSugerido || null,
                                            );
                                        }
                                    }}
                                    isDisabled={!tipoDestinoSeleccionado}
                                    placeholder={
                                        !tipoDestinoSeleccionado
                                            ? "Seleccionar destino"
                                            : "Seleccionar"
                                    }
                                />
                            )}
                        />
                        {errors.existencia && (
                            <small className="text-danger">
                                {errors.existencia.message}
                            </small>
                        )}
                    </div>

                    <div className="formulario-field">
                        <label className="text-nowrap">Kg disponibles</label>
                        <RenderKilogramo
                            className="form-control disabled-input"
                            value={
                                formValues.existencia &&
                                formValues.existencia.kg_secos
                                    ? formValues.existencia.kg_secos
                                    : ""
                            }
                            decimalScale={2}
                        />
                    </div>

                    <div className="formulario-field">
                        <label className="text-nowrap">Producto conforme</label>
                        <input
                            type="text"
                            className="form-control"
                            disabled
                            value={
                                formValues.existencia
                                    ? formValues.existencia.es_conforme_bodega
                                        ? "Sí"
                                        : "No"
                                    : ""
                            }
                        />
                    </div>

                    <div className="formulario-field">
                        <label className="text-nowrap">Kg a despachar</label>
                        <NumberField
                            control={formControl}
                            name="kg_consumo"
                            errors={errors}
                            allowNegative={false}
                            rules={{
                                required: "Este campo es obligatorio",
                                min: {
                                    value: 0.001,
                                    message: "Debe ser mayor a 0",
                                },
                                max: {
                                    value: limiteKg,
                                    message: `No puede superar los ${formatDisplayNumber(limiteKg, 2)} Kg disponibles`,
                                },
                            }}
                            decimalScale={2}
                            disabled={!formValues.existencia}
                        />
                    </div>

                    {esReclasificacion && (
                        <div className="formulario-field">
                            <label className="text-nowrap">
                                No. tarjeta amarilla
                            </label>
                            <TextField
                                control={formControl}
                                name="tarjeta_salida"
                                errors={errors}
                                placeholder="Ejemplo: 003-145"
                                rules={{
                                    required:
                                        "Debe indicar el número de tarjeta",
                                    validate: (value) =>
                                        !value ||
                                        !!value.trim() ||
                                        "El número de tarjeta no puede contener solo espacios",
                                }}
                            />
                        </div>
                    )}

                    {esReproceso && (
                        <div
                            className="formulario-field"
                            style={{ minWidth: "180px" }}
                        >
                            <label className="text-nowrap">
                                Almacén de reproceso
                            </label>
                            <Controller
                                name="bodega_destino"
                                control={formControl}
                                rules={{
                                    required:
                                        "Debe seleccionar el almacén de reproceso",
                                }}
                                render={({ field }) => (
                                    <AsyncSelect
                                        {...field}
                                        className="react-select-container"
                                        isSearchable
                                        isClearable
                                        defaultOptions
                                        loadOptions={loadAlmacenesReproceso}
                                        getOptionValue={(option) => option.id}
                                        getOptionLabel={(option) =>
                                            option.nombre
                                        }
                                        onChange={(selected) => {
                                            field.onChange(selected);
                                        }}
                                        isDisabled={!formValues.existencia}
                                        placeholder={
                                            !formValues.existencia
                                                ? "Seleccionar sobrante"
                                                : "Seleccionar"
                                        }
                                    />
                                )}
                            />
                            {errors.bodega_destino && (
                                <small className="text-danger">
                                    {errors.bodega_destino.message}
                                </small>
                            )}
                        </div>
                    )}

                    <div
                        className="formulario-field mb-0 ml-auto no-flex"
                        style={{ maxHeight: "57px" }}
                    >
                        <button
                            type="button"
                            className="btn btn-primary mt-auto"
                            onClick={AgregarDetalleSobrante}
                        >
                            Agregar
                        </button>
                    </div>
                </div>
            </div>

            {/* TABLA DE DETALLES DE SOBRANTE */}
            <div className="new-table-wrapper creacion-produccion__table-wrapper">
                <table className="table-striped">
                    <thead>
                        <tr>
                            <th>ACCIONES</th>
                            <th>PRODUCTO</th>
                            <th>CONFORME</th>
                            <th>KG SECOS</th>
                            {esReclasificacion && <th>TARJETA AMARILLA</th>}
                            {esReproceso && <th>ALMACÉN DE REPROCESO</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {detallesSobrante.length === 0 && (
                            <tr>
                                <td
                                    className="text-center"
                                    colSpan={
                                        esReclasificacion || esReproceso
                                            ? 5
                                            : 4
                                    }
                                >
                                    No se han agregado sobrantes a despachar
                                </td>
                            </tr>
                        )}
                        {detallesSobrante.map((item, index) => {
                            return (
                                <tr key={index}>
                                    <td className="text-center text-nowrap">
                                        <div className="table-actions">
                                            <img
                                                src={eliminarIcon}
                                                alt="Eliminar"
                                                className="action_img"
                                                title="Eliminar"
                                                onClick={() =>
                                                    EliminarDetalleSobrante(
                                                        index,
                                                    )
                                                }
                                            />
                                        </div>
                                    </td>
                                    <td className="text-center text-nowrap">
                                        {item.producto}
                                    </td>
                                    <td className="text-center text-nowrap">
                                        {item.es_conforme_bodega ? "Sí" : "No"}
                                    </td>
                                    <td className="text-center text-nowrap">
                                        <RenderKilogramo
                                            value={item.kg_secos}
                                            decimalScale={2}
                                        />
                                    </td>
                                    {esReclasificacion && (
                                        <td className="text-center text-nowrap">
                                            <NullableValue
                                                value={item.tarjeta_salida}
                                            >
                                                <Badge
                                                    text={item.tarjeta_salida}
                                                    variant={"warning"}
                                                />
                                            </NullableValue>
                                        </td>
                                    )}
                                    {esReproceso && (
                                        <td className="text-center text-nowrap">
                                            <NullableValue
                                                value={
                                                    item.bodega_destino_nombre
                                                }
                                            >
                                                {item.bodega_destino_nombre}
                                            </NullableValue>
                                        </td>
                                    )}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};
